import { IBackboneProduct } from '@ve/types/backboneModels/Domain/ObjectValue/BackboneProduct';
import {
 IReturnProductHotelOffer, IReturnProductRailways, IReturnProductTour,
} from '@ve/pages/hotel/types';
import FactoryProductsAdapt from '@ve/pages/hotel/adapters/FactoryProductsAdapt';

export default (tourProduct: IBackboneProduct): (IReturnProductHotelOffer | IReturnProductRailways | IReturnProductTour)[] => {
    const firstProduct = tourProduct;
    const arrayProductsHotelOffers = [
        firstProduct.get('type') === 'HotelOfferProduct' ? firstProduct : null,
        ...tourProduct.get('hotelOfferProducts'),
    ].map((hotelOffer) => FactoryProductsAdapt<IReturnProductHotelOffer>(hotelOffer))
    .filter((hotelOfferProduct) => !!hotelOfferProduct) as IReturnProductHotelOffer[];

    const arrayProductsRailways = [
        firstProduct.get('type') === 'RailwayTourProduct' ? firstProduct : null,
        ...tourProduct.get('railwayProducts'),
    ].map((railwayTour) => FactoryProductsAdapt<IReturnProductRailways>(railwayTour))
    .filter((railwayTourProduct) => !!railwayTourProduct) as IReturnProductRailways[];

    const arrayProductsTours = [
        firstProduct.get('type') === 'TourProduct' ? firstProduct : null,
        ...tourProduct.get('tourProducts'),
    ].map((tour) => FactoryProductsAdapt<IReturnProductTour>(tour))
    .filter((productTour) => !!productTour) as IReturnProductTour[];

    return [...arrayProductsTours, ...arrayProductsHotelOffers, ...arrayProductsRailways];
};